import classNames from 'classnames';

import useNavigationHandler from '../../../hooks/useNavigationHandler/useNavigationHandler';

import Icon from '../../../components/Icon/Icon';

import { TProject } from '../../../types/TProject';

import commons from '../../../shared/styles/common.module.scss';
import styles from './ProjectItem.module.scss';

type TProps = {
  project: TProject;
};

const ProjectItem = ({ project }: TProps) => {
  const { createNavigationHandler } = useNavigationHandler();

  return (
    <div className={classNames(styles.projectContainer, commons.container)}>
      <div className={styles.projectContent}>
        <a
          key={project.id}
          href={String(project.id)}
          onClick={(e) => {
            e.preventDefault();
            createNavigationHandler(project.id, 'projectPage', ':projectId');
          }}
          className={styles.projectWrapper}>
          <div className={styles.projectText}>
            <div className={styles.projectTitleWrapper}>
              <Icon name='fa-folder' color='icon-brown' size={20} />
              <h4 className={styles.projectTitle}>{project.title}</h4>
            </div>
            <p className={styles.projectExcerpt}>{project.excerpt}</p>
          </div>
        </a>
      </div>
    </div>
  );
};

export default ProjectItem;
